import { useEffect } from "react";

const DEFAULTS = {
  title: "ConstruLink · Ecosistema de la Construcción",
  description: "ConstruLink · Plataforma Integral para la Industria de la Construcción.",
  image: "https://customer-assets.emergentagent.com/job_2020ccb9-f12e-4465-851a-352c12d62fdc/artifacts/rubhbfe7_Logo%20CONSTRULINK%20--f%20transparente.png",
};

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Componente ligero de SEO/OpenGraph (sin dependencias). Actualiza title y metatags.
export default function Seo({ title, description, image, type = "website" }) {
  useEffect(() => {
    const t = title ? `${title} · ConstruLink` : DEFAULTS.title;
    const d = description || DEFAULTS.description;
    const img = image || DEFAULTS.image;
    document.title = t;
    setMeta("name", "description", d);
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", d);
    setMeta("property", "og:image", img);
    setMeta("property", "og:type", type);
    setMeta("property", "og:site_name", "ConstruLink");
    setMeta("property", "og:url", window.location.href);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", t);
    setMeta("name", "twitter:description", d);
    setMeta("name", "twitter:image", img);
    return () => { document.title = DEFAULTS.title; };
  }, [title, description, image, type]);
  return null;
}
